import { PATH, Storage, Envs, Utils } from '@common';
import { React, Redirect, Route, Switch } from '@common/3rd';
import DeskNotFound from './desk-not-found';
import DeskHome from './desk-home';
import ResetPasswordComp from './sign/reset-password';

const Sign = React.lazy(() => import(/* webpackChunkName: "desk2-sign" */ './sign'));
const ResetPassword = React.lazy(() => import(/* webpackChunkName: "desk2-reset-password" */ './sign/reset-password'));
const Product = React.lazy(() => import(/* webpackChunkName: "desk2-product" */ './product'));
const EnterpriseExclusive = React.lazy(() => import(/* webpackChunkName: "desk2-enterprise-exclusive" */ './enterprise-exclusive'));
const Disclosure = React.lazy(() => import(/* webpackChunkName: "desk2-disclosure" */ './disclosure'));
const AboutUs = React.lazy(() => import(/* webpackChunkName: "desk2-about-us" */ './about-us'));
const Help = React.lazy(() => import(/* webpackChunkName: "desk2-help" */ './help'));
const PersonalCenter = React.lazy(() => import(/* webpackChunkName: "desk2-personal-center" */ './personal-center'));
const MobileIframe = React.lazy(() => import(/* webpackChunkName: "desk2-mobile-iframe" */ './desk-mobile-frame'));

class DeskRoute extends React.Component {
	state = {};
	constructor(props: any, context?: any) {
		super(props, context);
		//绑定设置第三方地址
		Storage.Share.holderThirdDeskHome();
		Storage.Share.holderThirdDeskLogin();
	}
	handleNotDesk() {
		let result = false;
		const pathMap = {
			[PATH.DESK2_SIGN_IN]: '/csms2/mall/sign/in',
			[PATH.DESK2_SIGN_UP]: '/csms2/mall/sign/up',
			[PATH.DESK2_RESET_PASSWORD]: '/csms2/mall/forgetpassword',
			[PATH.DESK2_HOME]: '/csms2/mall/home',
			[PATH.DESK2_ENTERPRISE_EXCLUSIVE]: '/csms2/mall/enterprises-select',
			[PATH.DESK2_PRODUCT_MAIN]: '/csms2/mall/product',
			[PATH.DESK2_ABOUT_US]: '/csms2/mall/about-us',
			[PATH.DESK2_DISCLOSURE_MAIN]: '/csms2/mall/disclosure',
			[PATH.DESK2_PERSONAL_POLICY]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_SETTING]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_MODIFY_MOBILE]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_MODIFY_PWD]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_AGREEMENT]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_STATEMENT]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_COOKIE_STATEMENT]: '/csms2/mall/me',
			[PATH.DESK2_PERSONAL_CUSTOMER_SERVICE]: '/csms2/mall/customer-service',
			[PATH.DESK2_PERSONAL_FAMILY_MEMBER]: '/csms2/mall/family-member/list',
			[PATH.DESK2_PRODUCT_SEARCH_RESULT.replace(":keyword","[\\S]{1,}")]: (()=>{
				const pathname = window.location.pathname;
				if(!Utils.isBlank(pathname)){
					//@ts-ignore
					const keyWord = pathname.substring(pathname.lastIndexOf('/')+1);
					//@ts-ignore
					const searchProduct = pathname.substring(0,pathname.lastIndexOf('/'));
					if(searchProduct === '/csms/pc/product/search'){
						//@ts-ignore
						return '/csms2/mall/search-product/' + keyWord;	
					}else{
						//@ts-ignore
						const vendor = searchProduct.substring(searchProduct.lastIndexOf('/') + 1);
						//@ts-ignore
						return '/csms2/mall/search-product/' + keyWord + `?vendor=${vendor}`;
					}
				}else{
					return '/csms2/mall/search-product';
				}
			})(),
			[PATH.DESK2_HELP]: '/csms2/mall/help'
		}
		let currentUrl = window.location.href.split('?')[0];
		Object.entries(pathMap).forEach(([deskPath, mobilePath]) => {
			if (new RegExp(deskPath + '$').test(currentUrl)) {
				let mobileUrl = window.location.origin + mobilePath;
				if (window.location.href.split('?')[1]) {
					mobileUrl += `?${window.location.href.split('?')[1]}`;
				}
				window.location.replace(mobileUrl);
				result = true;
			}
			// if (deskPath === PATH.DESK2_HOME && new RegExp('/csms/pc/.+' + '$').test(window.location.pathname)) {
			// 	let matches = new RegExp('/csms/pc/(.+)' + '$').exec(window.location.pathname);
            //     if (matches && matches[1] && decodeURIComponent((matches[1])).startsWith('{AES}')) {
            //         let mobileUrl = window.location.href.replace('/csms/pc/', '/csms2/mall/home/');
            //     	window.location.replace(mobileUrl);
            //         result = true;
            //     }
            // }
		});
		return result;
	}
	render() {
		let jump = false;
		if (window.location.host.includes('mej') || process.env.NODE_ENV === 'development') {
			if (!Envs.isDesk()) {
				jump = this.handleNotDesk();
			}
		}
		if (jump) {
			return <></>;
		}
		return (
			<Switch>
				<Route path={PATH.DESK2_SIGN} render={() => <Sign />} />
				<Route exact path={PATH.DESK2_RESET_PASSWORD_VENDOR} render={({ match }) => <ResetPasswordComp vendor={match.params.vendor} path={PATH.DESK2_RESET_PASSWORD_VENDOR}/>} />
				<Route path={PATH.DESK2_RESET_PASSWORD} component={ResetPassword} />
				<Route path={PATH.DESK2_PRODUCT} component={Product} />
				<Route path={PATH.DESK2_ENTERPRISE_EXCLUSIVE} render={() => <EnterpriseExclusive />} />
				<Route path={PATH.DESK2_DISCLOSURE} component={Disclosure} />
				<Route path={PATH.DESK2_ABOUT_US} component={AboutUs} />
				<Route path={PATH.DESK2_HELP} component={Help} />
				<Route path={PATH.DESK2_PERSONAL_CENTER} render={() => <PersonalCenter />} />
				<Route path={PATH.DESK2_MOBILE_IFRAME} render={() => <MobileIframe />}  />
                <Route
					path="/*"
					render={() => {
						if (!Envs.isAuthorized()) {
							return (
								<Switch>
									<Route exact path={PATH.DESK2_HOME_VENDOR} render={({ match }) => <DeskHome vendor={match.params.vendor} path={PATH.DESK2_HOME_VENDOR}/>} />
									<Route exact path={PATH.DESK2_HOME} render={() => <DeskHome />} />
									<Redirect to={PATH.DESK2_SIGN_IN} />
								</Switch>
							);
						} else {
							return (
								<Switch>
									<Route exact path={PATH.DESK2_NOT_FOUND} render={() => <DeskNotFound />} />
									<Route exact path={PATH.DESK2_HOME_VENDOR} render={({ match }) => <DeskHome vendor={match.params.vendor} path={PATH.DESK2_HOME_VENDOR}/>} />
									<Route exact path={PATH.DESK2_HOME} render={() => <DeskHome />} />
									<Redirect to={PATH.DESK2_NOT_FOUND} />
								</Switch>
							);
						}
					}}
				/>
			</Switch>
		);
	}
}

export default DeskRoute;
